<script lang="ts">
    import queryString from "query-string";
    import { Col, Container, Row } from "sveltestrap";
    import AngleStart from "../svg/shapes/AngleStart.svelte";
    import { appManager } from "../AppManagerStore";
    import { navigate } from "svelte-navigator";
    import { _ } from "svelte-i18n";

    let ok: boolean = false;
    let email: string = "";

    let onSave = async () => {
        // send forgot password request.
        ok = await $appManager.IdentityApi.forgotPassword({
            email: email as string,
            url: `${$appManager.PublicUrl}resetpassword`,
        });

        if (ok) {
            setTimeout(() => {
                navigate(`${$appManager.PublicUrl}`, { replace: true });
            }, 3000);
        }
    };
</script>

<section>
    <Container class="d-flex flex-column">
        <Row class="align-items-center justify-content-center gx-0 min-vh-100">
            <Col>
                {#if ok}
                    <h1 class="mb-0 fw-bold">
                        {$_("user.forgotpass.thanks")} 👍
                    </h1>

                    <p class="mb-6 text-muted">
                        {$_("user.forgotpass.thankssubtitle")}
                    </p>

                    <p class="mb-6 text-muted">
                        {$_("user.forgotpass.redirect.part1")}
                        <a href="{$appManager.PublicUrl}"
                            >{$_("user.forgotpass.redirect.here")}</a>
                        {$_("user.forgotpass.redirect.part2")}
                    </p>
                {:else}
                    <h1 class="mb-0 fw-bold">
                        {$_("user.forgotpass.title")}
                    </h1>

                    <p class="mb-6 text-muted">
                        {$_("user.forgotpass.subtitle")}
                    </p>

                    <div class="mb-6">
                        <div class="form-group">
                            <label class="form-label" for="email">
                                {$_("user.forgotpass.email")}
                            </label>
                            <input
                                type="email"
                                class="form-control"
                                id="email"
                                placeholder={$_(
                                    "user.forgotpass.emailplaceholder"
                                )}
                                bind:value={email} />
                        </div>

                        <button
                            class="btn w-100 btn-primary"
                            on:click={async () => await onSave()}>
                            {$_("user.forgotpass.ok")}
                        </button>
                    </div>

                    <p class="mb-0 fs-sm text-muted">
                        {$_("user.forgotpass.remember")}
                        <a href="{$appManager.PublicUrl}signin"
                            >{$_("user.forgotpass.signin")}</a
                        >.
                    </p>
                {/if}
            </Col>

            <div
                class="col-lg-7 offset-lg-1 align-self-stretch d-none d-lg-block">
                <div
                    class="h-100 w-cover bg-cover"
                    style="background-image: url(/img/covers/cover-15.jpg);" />

                <div class="shape shape-start shape-fluid-y text-white">
                    <AngleStart />
                </div>
            </div>
        </Row>
    </Container>
</section>
